import type { SVGProps } from 'react';
import * as React from 'react';

const SvgAlertTriangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    fill="currentColor"
    height="100%"
    viewBox="0 0 16 16"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M7.64 1.221a1.17 1.17 0 0 1 .834.044c.224.1.376.279.491.442.117.164.243.385.39.638l5.484 9.47c.147.255.274.475.36.66.083.18.164.402.138.647a1.17 1.17 0 0 1-.474.823c-.2.144-.43.187-.63.205-.201.018-.457.018-.75.018H2.516c-.293 0-.549 0-.75-.018s-.431-.06-.63-.205a1.17 1.17 0 0 1-.475-.823c-.025-.245.055-.466.139-.648.085-.184.213-.405.36-.658l.514-.889.172-.295.684-1.184.172-.296.686-1.184.172-.296.684-1.184.172-.295 2.228-3.848c.146-.253.274-.474.39-.638.116-.163.267-.342.492-.442zm.352 9.68a.6.6 0 1 0 0 1.2H8a.6.6 0 0 0 0-1.2zM8 4.9a.6.6 0 0 0-.6.6v3a.6.6 0 0 0 1.2 0v-3a.6.6 0 0 0-.6-.6"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgAlertTriangle;
